import { z } from 'zod';
import { viaRequestControlsSchema } from './controls';
import { viaOrganizationSkillsSchema } from './org-skills';
export const viaPageContextSchema = z.object({
    routeId: z.string(),
    url: z.string(),
    title: z.string().optional()
});
export const VIA_MESSAGE_STAMP_KEY = 'viaStamp';
/** Review: Via's changes wait for the user to accept them. Auto: Via applies and saves them itself. */
export const viaChatModeSchema = z.enum(['review', 'auto']);
/** Values the server hands a chat to send back, by name; the server checks each one it gets back. */
export const viaCarriedSchema = z.record(z.string(), z.string());
/** Starts the SSE comment line that hands those values over; a browser that doesn't know it skips it. */
export const VIA_CARRIED_LINE_PREFIX = ': via-carried ';
export const viaForwardedPropsSchema = z.object({
    pageContext: viaPageContextSchema.optional(),
    skill: z.string().optional(),
    mode: viaChatModeSchema.default('review'),
    organizationSkills: viaOrganizationSkillsSchema.default([]),
    /** The user's IANA time zone, such as "America/New_York", so Via knows what "today" means for them. */
    timeZone: z.string().optional(),
    /**
     * What the user lets Via do. A browser from before controls, or with them behind the flag, leaves it out, and the
     * chat then works as it did before controls. A value that isn't controls at all counts as left out.
     */
    controls: viaRequestControlsSchema.optional().catch(undefined),
    /** Unreadable counts as none; only the names the server uses are read, so extra names cost nothing. */
    carried: z.object({ skills: z.string().optional() }).optional().catch(undefined)
});
/** Fixed on a message as it's sent, so every request reads the same time and page for it. */
export const viaMessageStampSchema = viaForwardedPropsSchema
    .pick({ pageContext: true, skill: true, timeZone: true })
    .extend({
    /** When the user sent the message, in milliseconds since 1970. A number above the limit isn't a date. */
    sentAt: z.number().min(0).max(8.64e15)
});
/**
 * The longest a reply's stream stays silent. The server writes a line this often whether or not Via has anything to
 * send, and the browser takes a silence several times as long for a connection that died.
 */
export const VIA_KEEP_ALIVE_INTERVAL_MS = 15_000;
/**
 * What Via reads as the result of a step that was cut off before it finished, by Stop or by its page closing. The
 * browser puts it on such a step in what it sends, and the server on one that arrives without it.
 */
export const VIA_STOPPED_STEP = {
    error: 'This step was stopped before it finished. It may have partly run, so check before doing it again.'
};
//# sourceMappingURL=chat-request.js.map